import { Reducer } from "redux";
import {
  ClinicInformationState,
  ClinicInformationActions,
  LoadClinicInformationAction
} from "./type";
import {
  loadClinicInformationHandler
} from "./handlers";
import {
  LOAD_CLINIC_INFORMATION,
  CLEAN_SITE_INFORMATION
} from "./constants";
import { CountryCodes } from "../../constants/countries";
import { FeatureSwitchDto, MyleInstanceClinicSettings } from "../../dtos/KioskDtos.dtos";

export const initialState: ClinicInformationState = {
    sites: [],
    clinicName: "",
    clinicCountry: CountryCodes.CA,
    clinicRegion: "QC",
    enText: null,
    frText: null,
    esText: null,
    featureFlags: new FeatureSwitchDto(),
    myleClinicSettings: new MyleInstanceClinicSettings(),
    healthCards: []
};

const reducer: Reducer<ClinicInformationState> = (state: ClinicInformationState = initialState, action: ClinicInformationActions) => {
    switch (action.type) {
        case LOAD_CLINIC_INFORMATION:
            return loadClinicInformationHandler(state, action as LoadClinicInformationAction);

        case CLEAN_SITE_INFORMATION:
            return initialState;

        default:
            return state;
    }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/store/ClinicInformation/reducer.ts